const addPropToAllChildren = (children, props) => {
    return children?.map((child) => {
        const newChild = { ...child, props: { ...child.props, ...props } };
        if (newChild.children) {
            newChild.children = addPropToAllChildren(child.children, props);
        }
        return newChild;
    });
};
export default addPropToAllChildren;
//# sourceMappingURL=addPropToAllChilds.js.map